import {createFileRoute} from '@tanstack/react-router'
import LandingPage from "../landing/LandingPage.tsx";

export const Route = createFileRoute('/')({
    component: Index,
})

function Index() {
    return <LandingPage />
}
